export default __webpack_public_path__ + "static/media/loNathTome1.73a15315.webp";